const practiceSamples = {
  "mix": [
    {
      "round": "Emoji Hits",
      "kind": "emoji",
      "question": "Twee emoji’s, één rockklassieker. Welke songtitel zoeken we?",
      "emoji": "🔪 👑",
      "answer": "Killer Queen",
      "answerDetail": "Van Queen. Killer + Queen. De tweede emoji geeft dus ook een hint naar de band."
    },
    {
      "round": "Algemene kennis",
      "kind": "knowledge",
      "question": "Je koptelefoon heeft verbinding. Maar welke draadloze techniek is vernoemd naar een middeleeuwse Scandinavische koning?",
      "answer": "Bluetooth",
      "answerDetail": "Harald Blåtand, oftewel Harald Bluetooth. De koning verbond volkeren; zijn naam verbindt nu jullie apparaten."
    },
    {
      "round": "Wereldreis",
      "kind": "knowledge",
      "question": "Jullie plannen een wereldwijde quizavond. Welk van deze landen heeft de meeste tijdzones? Tel de overzeese gebieden mee.",
      "options": [
        "Rusland",
        "Frankrijk",
        "China"
      ],
      "answer": "Frankrijk",
      "answerDetail": "De overzeese gebieden maken het verschil: van Frans-Polynesië tot Réunion. Europees Frankrijk alleen heeft uiteraard niet al die tijdzones."
    },
    {
      "round": "Waar of niet waar",
      "kind": "boolean",
      "question": "Aan de Universiteit van Oxford werd al lesgegeven voordat het Azteekse Rijk ontstond.",
      "answer": "Waar",
      "answerDetail": "In Oxford werd in 1096 al lesgegeven. Het Azteekse Rijk ontstond in 1428: ruim drie eeuwen later. De geschiedenis loopt soms anders dan je denkt."
    }
  ],
  "team": [
    {
      "round": "Leg de link",
      "kind": "connection",
      "question": "Deze drie namen klinken alsof ze niet bij elkaar horen. Wat hebben ze op de menukaart gemeen?",
      "clues": [
        "Caesar",
        "Waldorf",
        "Niçoise"
      ],
      "answer": "Het zijn alle drie salades",
      "answerDetail": "Caesarsalade, Waldorfsalade en salade niçoise. Niet alles aan de quiztafel hoeft een bitterbal te zijn."
    },
    {
      "round": "Zeg dat dan!",
      "kind": "wordplay",
      "question": "Jullie vieren de winst vóór de laatste ronde. Welke uitdrukking past daarbij? De hints nemen we letterlijk.",
      "clues": [
        "Er wordt alvast iets verkocht.",
        "De oorspronkelijke drager loopt nog in het bos."
      ],
      "answer": "De huid verkopen voordat de beer geschoten is",
      "answerDetail": "Je rekent op succes voordat je het echt hebt behaald. Eerst die laatste ronde nog…"
    },
    {
      "round": "Alles op een rij",
      "kind": "ordering",
      "question": "Festivalplanning! Zet de optredens op volgorde van eindtijd: vroeg naar laat. Ze beginnen op tijd, zonder toegift.",
      "options": [
        "De Dwaallichten · start 20:40 · 75 minuten",
        "Neon Nachten · start 21:15 · 45 minuten",
        "De Laatste Ronde · start 21:10 · 55 minuten",
        "Disco Dodo · start 20:55 · 50 minuten"
      ],
      "answer": "D → A → B → C",
      "answerDetail": "Disco Dodo 21:45 → De Dwaallichten 21:55 → Neon Nachten 22:00 → De Laatste Ronde 22:05. Alle namen zijn verzonnen voor deze puzzel."
    },
    {
      "round": "Zoek de verschillen",
      "kind": "differences",
      "question": "Welke drie verschillen zien jullie tussen beeld A en beeld B?",
      "answer": "De vogel, de minutenwijzer en de kleur van de mok",
      "answerDetail": "In de antwoordbeelden zijn de drie verschillen omcirkeld en genummerd.",
      "media": {
        "type": "image",
        "presentation": "comparison",
        "src": "__DIFF_A__",
        "compareSrc": "__DIFF_B__",
        "alt": "Een geïllustreerde lunchruimte. Zoek drie verschillen tussen beeld A en beeld B."
      },
      "answerMedia": {
        "type": "image",
        "presentation": "comparison",
        "src": "__DIFF_A_ANSWER__",
        "compareSrc": "__DIFF_B_ANSWER__",
        "alt": "De drie verschillen zijn omcirkeld en genummerd: vogel, minutenwijzer en mok."
      }
    }
  ]
};
